import { AccountInfo } from "@azure/msal-browser";
import { IMsalContext } from "@azure/msal-react";
import { isDevelopment } from "../const";
import { loginRequest } from "./auth";

export const getAccessToken = async (msalInstance: IMsalContext, forceRefresh = false) => {
  if (!isDevelopment) {
    const instance = msalInstance.instance;
    let accounts: AccountInfo[] = [];

    try {
      await instance.initialize();
      const res = await instance.handleRedirectPromise();

      if (!res) {
        accounts = instance.getAllAccounts();
      }

      const currentAccount = (res && res.account) || accounts[0];

      const accessTokenRequest = {
        ...loginRequest,
        forceRefresh,
        account: currentAccount,
      };

      const token = await instance.acquireTokenSilent(accessTokenRequest);
      const claims: { exp?: number } = token.idTokenClaims;

      return {
        token: token.idToken,
        expiresOn: token.expiresOn,
        idTokenClaims: claims.exp,
        account: token.account,
        at: token.accessToken,
      };
    } catch (e) {
      console.error(e);
      return instance.loginRedirect(loginRequest);
    }
  }
};

export const getS3grantAccessToken = async (msalInstance: IMsalContext, forceRefresh = false) => {
  if (!isDevelopment) {
    const instance = msalInstance.instance;
    let accounts: AccountInfo[] = [];

    try {
      await instance.initialize();
      const res = await instance.handleRedirectPromise();

      if (!res) {
        accounts = instance.getAllAccounts();
      }

      const currentAccount = (res && res.account) || accounts[0];

      const accessTokenRequest = {
        ...loginRequest,
        forceRefresh,
        account: currentAccount,
      };

      const token = await instance.acquireTokenSilent(accessTokenRequest);
      const claims: { exp?: number } = token.idTokenClaims;

      return {
        token: token.idToken,
        expiresOn: token.expiresOn,
        idTokenClaims: claims.exp,
        at: token.accessToken,
      };
    } catch (e) {
      console.error(e);
      // return instance.loginRedirect(loginRequest);
    }
  }
};

export const refreshAccessToken = async (msalInstance: IMsalContext) => {
  if (!isDevelopment) {
    const instance = msalInstance.instance;
    let accounts: AccountInfo[] = [];

    try {
      await instance.initialize();
      const res = await instance.handleRedirectPromise();

      if (!res) {
        accounts = instance.getAllAccounts();
      }

      const currentAccount = (res && res.account) || accounts[0];

      const accessTokenRequest = {
        ...loginRequest,
        forceRefresh: true,
        account: currentAccount,
      };

      const token = await instance.acquireTokenSilent(accessTokenRequest);
      const claims: { exp?: number } = token.idTokenClaims;

      return {
        token: token.idToken,
        expiresOn: token.expiresOn,
        idTokenClaims: claims.exp,
      };
    } catch (e) {
      console.error(e);
      return instance.loginRedirect(loginRequest);
    }
  }
};
